/* Big Head Bob blog gate. Runs synchronously right after the gate markup
   so a returning reader never sees the overlay flash. */
(function () {
  var KEY = 'bhb_blog_gate_ok';
  var DAYS = 30;
  var gate = document.getElementById('bhbGate');
  if (!gate) return;

  function alreadyOk() {
    try {
      var v = localStorage.getItem(KEY);
      if (v && Date.now() - Number(v) < DAYS * 864e5) return true;
    } catch (e) {}
    try { return sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    return false;
  }
  function remember() {
    try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
  }
  function setPageHidden(on) {
    var page = document.getElementById('PageContainer');
    if (!page) return;
    if (on) page.setAttribute('aria-hidden', 'true');
    else page.removeAttribute('aria-hidden');
  }
  function close() {
    gate.hidden = true;
    document.documentElement.classList.remove('bhb-gate-open');
    setPageHidden(false);
  }

  if (alreadyOk()) { close(); return; }

  document.documentElement.classList.add('bhb-gate-open');
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { if (!gate.hidden) setPageHidden(true); });
  } else {
    setPageHidden(true);
  }

  var box = document.getElementById('bhbGateCheck');
  var yes = document.getElementById('bhbGateYes');
  var no = document.getElementById('bhbGateNo');
  var hint = document.getElementById('bhbGateHint');

  box.addEventListener('change', function () {
    yes.classList.toggle('is-ready', box.checked);
    if (box.checked) hint.hidden = true;
  });
  yes.addEventListener('click', function () {
    if (!box.checked) { hint.hidden = false; box.focus(); return; }
    remember();
    close();
  });
  no.addEventListener('click', function () {
    window.location.href = no.getAttribute('data-href') || '/';
  });

  var order = [box, yes, no];
  gate.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var first = order[0], last = order[order.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  setTimeout(function () { try { box.focus({ preventScroll: true }); } catch (e) { box.focus(); } }, 50);
})();
